import { IconButton, Popover, TableBody, TableCell, TableRow } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { useState } from 'react';
import { ProductListStyle } from '../../styles/ProductListStyle';
import NewLineProducts from './NewLineProducts';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import Utils from '@/common/utils/utils';
import { reorder } from '../../handler/ProductManagementHandler';
import OverFlowTooltipWithTabsMui from '../../../common/OverFlowTooltipWithTabsMui';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { cloneDeep } from 'lodash';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const ListItemProduct = ({
    onOpenEditionList,
    listDataProduct,
    setListDataProduct,
    setHasError,
    setIsEdit,
    setListDeleteProduct,
    setListEditStatusProduct,
    listDeleteProduct,
    listEditStatusProduct,
}) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [anchorEl, setAnchorEl] = useState(null);
    const [popoverId, setPopoverId] = useState();
    const [openConfirmDeleteProduct,setOpenConfirmDeleteProduct] = useState(false);
    const [deleteItem,setDeleteItem] = useState('');

    const classes = ProductListStyle();
    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const newItems = reorder(listDataProduct, result.source.index, result.destination.index);

        // Update the 'order' field for each item based on their new position
        const updatedItems = newItems.map((item, index) => {
            let newOrder = newItems.length - (index + 1);
            if (item.order !== newOrder) {
                item.isPositionChanged = true;
            }
            return {
                ...item,
                order: newItems.length - (index + 1)
            };
        });
        setIsEdit(true);
        setListDataProduct(updatedItems);
    };

    const handleClick = (event, item) => {
        // if(!item.isExistOnSaleEdition){
        //     return
        // }
        setAnchorEl(event.currentTarget);
        setPopoverId(item);
    };

    const handleOnSelectNewStatus = (selectedItemId, newStatus) => {
        const indexOfSelectItem = listDataProduct?.findIndex(item => {
            return item.id === selectedItemId;
        });

        let itemChangedStatus = listDataProduct[indexOfSelectItem];
        if(itemChangedStatus.status === newStatus){
            setAnchorEl(null);
            return;
        }
        itemChangedStatus.status = newStatus;
        listDataProduct[indexOfSelectItem] = itemChangedStatus;
        setListDataProduct(cloneDeep(listDataProduct));
        
        let newListEditStatusProduct = listEditStatusProduct?.filter(product => {
            return product.id !== selectedItemId && !listDeleteProduct.includes(selectedItemId);
        });
        newListEditStatusProduct.push({
            id: itemChangedStatus.id,
            status: itemChangedStatus.status
        });
        setListEditStatusProduct([...newListEditStatusProduct]);
        setAnchorEl(null);
        setIsEdit(true);
    };

    const handleDeleteItem = (itemId) => {
        setDeleteItem(itemId)
        setOpenConfirmDeleteProduct(true);
        setAnchorEl(null);
    }

    const confirmDeleteItemHandler = (itemId) => {
        setListDeleteProduct(prev => [...prev,itemId]);
        const newListDataProduct = listDataProduct?.filter(product => {
            return product.id !== itemId
        });
        setListDataProduct(cloneDeep(newListDataProduct));
        let newListEditStatusProduct = listEditStatusProduct?.filter(product => {
            return product.id !== itemId
        });
        if(newListEditStatusProduct.length !== listEditStatusProduct.length){
            setListEditStatusProduct([...newListEditStatusProduct])
        }
        setDeleteItem('');
        setOpenConfirmDeleteProduct(false)
        setIsEdit(true);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const getStatusItem = (item) => {
        if (Utils.isEmptyObject(item)) return null;
        if (item.status === ProductManagementConstant.STATUS.ON_SALES) {
            return (
                <div
                    className="name-prod-status"
                    onClick={event => handleClick(event, item.id)}
                >
                    {trI18n('CM-DROPDOWN-ON_SALE')}
                </div>
            );
        }
        return (
            <div
                className={item.isExistOnSaleEdition ? `name-prod-status status-inactive-sales` : `name-prod-status status-inactive-sales-disabled`}
                onClick={(event) => {
                if(!item.isExistOnSaleEdition) return  
                handleClick(event, item.id)}}
            >
                {trI18n('CM-DROPDOWN-INACTIVE-SALE')}
            </div>
        );
    };

    const renderLineCreateOrList = (provided, snapshot, item, index) => {
        if (item.createNewLine) {
            return (
                <NewLineProducts
                    product={item}
                    indexProduct={index}
                    provided={provided}
                    snapshot={snapshot}
                    setHasError={setHasError}
                    setListDataProduct={setListDataProduct}
                />
            );
        }
        return (
            <TableRow
                className={`item-product ${snapshot.isDragging ? 'dragging' : ''} ${
                    classes.itemProduct
                }`}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <TableCell>
                    <OverFlowTooltipWithTabsMui
                        value={item.name}
                        className={classes.tableCellItemProduct}
                    />
                </TableCell>
                <TableCell className={classes.tableCellActionItem}>
                    <div className="cell-prod-status">
                        {getStatusItem(item)}
                        <Popover
                            id={open ? 'status-popover' : undefined}
                            open={open && popoverId === item.id}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}
                        >
                            <ul className="list-status-sale">
                                <li
                                    className="item-status-selected"
                                    onClick={event =>
                                        handleOnSelectNewStatus(
                                            item.id,
                                            ProductManagementConstant.STATUS.ON_SALES
                                        )
                                    }
                                >
                                    <span className="status-onsales">
                                        {trI18n('CM-DROPDOWN-ON_SALE')}
                                    </span>
                                </li>
                                <li
                                    className="item-status-selected"
                                    onClick={event =>
                                        handleOnSelectNewStatus(
                                            item.id,
                                            ProductManagementConstant.STATUS.INACTIVE
                                        )
                                    }
                                >
                                    <span className="status-inactive-sales">
                                        {trI18n('CM-DROPDOWN-INACTIVE-SALE')}
                                    </span>
                                </li>
                            </ul>
                        </Popover>
                    </div>
                    <IconButton onClick={event => handleClick(event, `more-action-${item.id}`)}>
                        <img src="/assets/image/icon-nav-manage.svg" alt="" />
                    </IconButton>
                    <Popover
                        id={open ? 'more-action-popover' : undefined}
                        open={open && popoverId === `more-action-${item.id}`}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                    >
                        <ul>
                            <li
                                className="more-action-item-prod"
                                onClick={() =>
                                    onOpenEditionList(item, ProductManagementConstant.EDITION_LIST)
                                }
                            >
                                <span className="item">
                                    <img src="/assets/image/edit-icon.svg" alt="" />
                                </span>
                                <span className="text">{trI18n('USER01BTN007')}</span>
                            </li>
                            {item.status !== ProductManagementConstant.STATUS.ON_SALES && (
                                <li
                                    className="more-action-item-prod"
                                    onClick={event => {
                                        if (
                                            item.status ===
                                            ProductManagementConstant.STATUS.ON_SALES
                                        )
                                            return;
                                        handleDeleteItem(item.id);
                                    }}
                                >
                                    <span className="item">
                                        <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                    </span>
                                    <span className="text">{trI18n('USER01LB006')}</span>
                                </li>
                            )}
                        </ul>
                    </Popover>
                </TableCell>
            </TableRow>
        );
    };

    return (
        <>
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <TableBody
                        ref={provided.innerRef}
                        className={`${snapshot.isDraggingOver ? 'draggingOver' : ''}`}
                        {...provided.droppableProps}
                    >
                        {listDataProduct?.map((item, index) => (
                            <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                                {(provided, snapshot) =>
                                    renderLineCreateOrList(provided, snapshot, item, index)
                                }
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </TableBody>
                )}
            </Droppable>
        </DragDropContext>
        <ConfirmDialog
                isOpen={openConfirmDeleteProduct}
                msgConfirm={tr(
                    '{{item}}を完全削除します。宜しいでしょうか。'.replace(
                        '{{item}}',
                        ProductManagementConstant.NAME.PRODUCT
                    )
                )}
                okCallBack={ (event) => {
                    confirmDeleteItemHandler(deleteItem)
                }
                    
                }
                closeCallBack={() => {
                    setOpenConfirmDeleteProduct(false);
                    setDeleteItem('');
                }
                    
                }
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                isShowClassnameButton={false}
            />
        </>
    );
};

export default ListItemProduct;
